// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"1f435018","432":"64afe9da","453":"b16f5c7e","711":"204de8be","911":"d86b4ddb"}[chunkId] + ".chunk.js";
};